import { fluidSizes } from './fluidSizes';

const defaultSizes = {
	headerHeight: '80px',
	sidebarWidth: '300px',
	sidebarCollapsedWidth: '75px',
	footerHeight: '50px',
	contentPaddingTop: '2rem',
	contentPaddingRight: '2rem',
	contentPaddingBottom: '4rem',
	contentPaddingLeft: '2rem',
	SignUpRegisterSidebarWidth: `${fluidSizes(300, 800)}`,
	LoginScreenHeader: '260px',
	MainSiteContainerWidth: '1280px',
};

export default defaultSizes;
